module.exports = {
      id: "360-usage",
      viewBox: "0 0 86 62",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#360-usage",
      toString: function () {
        return this.url;
      }
    }